import { graphql } from 'react-relay';

export const orColumnQuery = graphql`
  query ORColumnQuery($id: ID!, $datetimeStart: DateTime, $datetimeEnd: DateTime) {
    operatingRoom(id: $id) {
      id
      name
      recordingAvailability
      surgeries(first: 20, datetimeStart: $datetimeStart, datetimeEnd: $datetimeEnd)
        @connection(key: "ORColumn_surgeries") {
        __id
        edges {
          node {
            id
            name
            plannedStart
            plannedStop
            estimatedStartTime
            estimatedStopTime
            actualStartTime
            actualStopTime
            patientMrn
            patientName
            surgeonName
            serviceName
            status
            scheduleStatus
            location {
              name
            }
            durations {
              dynamicDurationMinutes
              delayAfterMinutes
              plannedDurationMinutes
            }
            estimateSource
            template {
              category
            }
            events(first: 20) {
              edges {
                node {
                  id
                  happenedAt
                  type {
                    id
                    name
                  }
                }
              }
            }
            turnover {
              id
              name
              plannedStart
              plannedStop
              estimatedStartTime
              estimatedStopTime
              actualStartTime
              actualStopTime
              status
              scheduleStatus
              durations {
                dynamicDurationMinutes
                delayAfterMinutes
                plannedDurationMinutes
              }
              estimateSource
              template {
                category
              }
              events(first: 20) {
                edges {
                  node {
                    id
                    happenedAt
                    type {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
